/**
 * Created by harry on 09.03.17.
 */

'use strict';

var Emitter = require('cjs-emitter'),
    Section = require('./models/section'),
    Option  = require('./models/option'),

    provider = new Emitter();


if ( DEVELOP ) {
    window.ids = {};
}


provider.data = {
    root: []
};


provider.advanced = false;

/* eslint no-path-concat: 0 */
/**
 * Add new options to data.
 *
 * @param {Array} data - options array to add
 */
provider.addOptions = function ( data ) {
    var iteration, parent;

    for ( iteration = 0; iteration < data.length; iteration++ ) {
        // console.log(data[iteration].parent);
        parent = data[iteration].parent || 'root';
        // console.log('new option ' + data[iteration].id + ' to ' + parent);

        if ( DEVELOP ) {
            if ( !provider.data[parent] ) {
                throw new Error(__filename + ': Not found parent section "' + parent + '" for option ' + data[iteration].id);
            }

            if ( window.ids[data[iteration].id] ) {
                throw new Error(__filename + ': Found duplicate option id - "' + data[iteration].id + '"');
            }
            window.ids[data[iteration].id] = 1;
        }

        data[iteration] = new Option(data[iteration]);

        this.data[parent].push(data[iteration]);
    }

    provider.emit('content:added', {options: data});
};


/**
 * Remove options from data.
 *
 * @param {Array} data - options array to remove
 */
provider.removeOptions = function ( data ) {
    var iteration, parent,
        index = -1;

    for ( iteration = 0; iteration < data.length; iteration++ ) {
        parent = data[iteration].parent || 'root';

        if ( DEVELOP ) {
            if ( !window.ids[parent] ) {
                throw new Error(__filename + ': Not found section - "' + parent + '"');
            }

            if ( !window.ids[data[iteration].id] ) {
                throw new Error(__filename + ': Not found option - "' + data[iteration].id + '"');
            }

            window.ids[data[iteration].id] = 0;
        }

        index = this.data[parent].indexOf(data[iteration]);

        if ( DEVELOP ) {
            if ( index === -1 ) {
                throw new Error(__filename + ': Not found option - "' + data[iteration].id + '"');
            }
        }

        this.data[parent].splice(index, 1);
    }

    provider.emit('content:removed', {options: data});
};


/**
 * Add new sections to data.
 *
 * @param {Array} data - sections array to add
 */
provider.addSections = function ( data ) {
    var iteration, parent;

    for ( iteration = 0; iteration < data.length; iteration++ ) {
        parent = data[iteration].parent || 'root';
        // console.log('new section ' + data[iteration].id + ' to ' + parent);

        if ( DEVELOP ) {
            if ( !provider.data[parent] ) {
                throw new Error(__filename + ': Not found parent section id - "' + parent + '" for option ' + data[iteration].id);
            }
            if ( window.ids[data[iteration].id] ) {
                throw new Error(__filename + ': Found duplicate section id - "' + data[iteration].id + '"');
            }
            window.ids[data[iteration].id] = 1;
        }

        data[iteration] = new Section(data[iteration]);

        this.data[parent].push(data[iteration]);
        this.data[data[iteration].id] = [];
    }

    provider.emit('content:added', {sections: data});
};


/**
 * Remove sections from data.
 *
 * @param {Array} data - sections array to remove
 */
provider.removeSections = function ( data ) {
    var iteration, parent, index;
    // changes = [];

    for ( iteration = 0; iteration < data.length; iteration++ ) {
        parent = data[iteration].parent || 'root';

        if ( DEVELOP ) {
            if ( !window.ids[parent] ) {
                throw new Error(__filename + ': Not found parent section - "' + parent + '"');
            }

            if ( !window.ids[data[iteration].id] ) {
                throw new Error(__filename + ': Not found section - "' + data[iteration].id + '"');
            }

            window.ids[data[iteration].id] = null;
        }

        index = this.data[parent].indexOf(data[iteration]);

        if ( DEVELOP ) {
            if ( index === -1 ) {
                throw new Error(__filename + ': Not found section - "' + data[iteration].id + '"');
            }
        }

        this.data[parent][index] = null;
        this.data[parent].splice(index, 1);

    }

    // provider.emit('content:removed', {sections: changes});
};


provider.addContent = function ( data ) {
    var self = this;

    data.forEach(function ( item ) {
        if ( item.type === 'section' ) {
            self.addSections([item]);

            return;
        }

        if ( item.type === 'option' ) {
            self.addOptions([item]);

            return;
        }

        if ( DEVELOP ) {
            throw new Error(__filename + ' content item must have type, id: ' + item.id);
        }
    });
};


provider.removeContent = function ( data ) {
    var self = this;

    data.forEach(function ( item ) {
        if ( item.type === 'section' ) {
            self.removeSections([item]);

            return;
        }
        if ( item.type === 'option' ) {
            self.removeOptions([item]);

            return;
        }

        if ( DEVELOP ) {
            throw new Error(__filename + ' content item must have type, id: ' + item.id);
        }
    });
};


provider.getContent = function ( sectionId, filterCallback ) {
    var data  = [],
        index = 0,
        size  = 0;

    if ( this.data[sectionId] ) {
        size = this.data[sectionId].length;
        if ( typeof filterCallback === 'function' ) {
            // filter enabled
            data = [];
            while ( index < size ) {
                if ( filterCallback(this.data[sectionId][index]) ) {
                    data.push(this.data[sectionId][index]);
                }
                ++index;
            }
        } else {
            data = this.data[sectionId];
        }
    }

    return data;
};


provider.clearSection = function ( id ) {
    var self = this;

    this.data[id].forEach(function ( item ) {
        if ( DEVELOP ) {
            // console.log('clear ' + item.id);
            window.ids[item.id] = null;
            if ( self.data[item.id] ) {
                self.data[item.id].forEach(function ( child ) {
                    // console.log('clear ' + child.id);
                    window.ids[child.id] = null;
                });
            }
        }
        if ( self.data[item.id] ) {
            // section
            self.clearSection(item.id);
        }
    });

    this.data[id] = [];
};

module.exports = provider;
